<template>
  <div class="page-container">
    <div
      class="scroll-container"
      ref="scrollContainer"
      @scroll="handleScroll"
      v-if="list.length"
    >
      <div class="card-item" v-for="branch in list" :key="branch.id">
        <div class="title">{{ branch.networkName }}</div>
        <div class="address">{{ branch.networkAddr }}</div>
        <div class="bottom-card">
          <div>可寄产品种类:{{ branch.productName }}</div>
          <div>
            联系电话：
            <span class="link">{{ branch.customerServicePhone }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="no-data" v-else>
      <no-result-box
        resultUrl="https://ump.ems.com.cn/newmail-resources/images/tips/place-flag@3x.png"
        resultNull="查询不到网点"
      ></no-result-box>
    </div>
  </div>
</template>

<script>
import { setDocumentTitle } from '@/plugin/setTitle'
import { findNearbyOfficeApi } from '@/api/protocol'
import NoResultBox from '@/components/noResult/NoResultBox.vue' // 无结果

export default {
  mounted () {
    setDocumentTitle('附近网点')
    this.findNearbyOffice()
  },
  data () {
    return {
      pageNo: 1,
      pageSize: 20,
      list: [],
      pageCount: 0,
      loading: false
    }
  },
  //   watch: {
  //     '$route.query': function(newVal, oldVal) {
  //       this.query = newVal
  //       this.findNearbyOffice()
  //     }
  //   },
  activated () {
    console.log('activated调用了')
    this.findNearbyOffice()
  },
  methods: {
    // 查询网点
    async findNearbyOffice (pageNo = this.pageNo) {
      if (this.loading) return
      let { provinceNo, cityNo, countyNo, isEommerce } = this.$route.query
      if (provinceNo) {
        this.loading = true
        let nearbyParamData = {
          senderProvCode: provinceNo,
          senderCityCode: cityNo,
          senderCountyCode: countyNo,
          pageNo: pageNo,
          pageSize: this.pageSize
        }
        // e邮宝揽收服务网点查询
        let eommerNearByParamData = {
          senderProvCode: provinceNo,
          senderCityCode: cityNo,
          eommerceNo: '00',
          pageNo: pageNo,
          pageSize: this.pageSize
        }
        let paramsData = isEommerce ? eommerNearByParamData : nearbyParamData
        let res = await findNearbyOfficeApi(paramsData)
        this.loading = false
        console.log('res', res)
        if (res.code === '000000') {
          this.pageNo = pageNo
          this.pageCount = res.info.totalCount
          if (this.pageNo === 1) {
            this.list = res.info.items
          } else {
            this.list = this.list.concat(res.info.items)
          }
        }
      }
    },
    loadMore () {
      if (this.pageNo < this.pageCount) {
        this.findNearbyOffice(this.pageNo + 1)
      }
    },

    handleScroll () {
      const container = this.$refs.scrollContainer
      const threshold = 50
      if (
        container.scrollTop + container.clientHeight >=
          container.scrollHeight - threshold &&
        !this.loading
      ) {
        this.loadMore()
      }
    }
  },
  components: {
    NoResultBox
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
